/**
 * constants.ts — Static lookup tables for P9_Reveal.
 *
 * Icons, labels, and navigation targets are kept here so the main
 * component file stays focused on state & render logic.
 */

// ── Phase-1 contextual icons ───────────────────────────────────────────────────

export const FASE_1_ICONS: Record<string, string> = {
  raza_edad: '🐾',
  peso: '⚖️',
  actividad: '🏃',
  comida: '🍲',
  salud: '💚',
};

// ── Phase-2 contextual icons ───────────────────────────────────────────────────

export const FASE_2_ICONS: Record<string, string> = {
  kcal: '🔥',
  grams: '📏',
  recipes: '📋',
  supplements: '💊',
};

// ── Phase-2 row labels ─────────────────────────────────────────────────────────
// When the calculation resolves, the number replaces the "…" inside the label
// (e.g. "1040 kcal diarias" or "4 recetas idóneas").

export const FASE_2_PENDING_LABELS: Record<string, string> = {
  kcal: 'kcal diarias',
  grams: 'gramos al día',
  recipes: 'recetas idóneas',
  supplements: 'suplementos recomendados',
};

// ── Click-to-edit: stage key → funnel step number ────────────────────────────

// Stage key → step number that owns the underlying data. Used by the
// click-to-edit affordance on the Phase 1 profile panel: tapping a row
// pops a confirm dialog and, on confirm, navigates back to that step
// so the user can change the value and walk forward again.
export const STAGE_TO_STEP: Record<string, number> = {
  // Stage 'raza_edad' shows breed + age + gender. Step 2 (P2_DatosBasicos)
  // is the earliest step that owns any of those fields (name/age/gender);
  // the user can navigate forward to P3_Raza if it's the breed they want
  // to change. Two steps removed in the worst case is still better than
  // restarting the whole funnel.
  raza_edad: 2,
  peso: 4,
  actividad: 5,
  comida: 6,
  salud: 8,
};

export const STAGE_EDIT_LABEL: Record<string, string> = {
  raza_edad: 'datos básicos (nombre, raza, edad)',
  peso: 'peso y condición corporal',
  actividad: 'nivel de actividad',
  comida: 'tipo de comida',
  salud: 'estado de salud',
};
